var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDotsBig(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.9987 13.3333C6.53203 13.3333 5.33203 14.5333 5.33203 16C5.33203 17.4666 6.53203 18.6666 7.9987 18.6666C9.46536 18.6666 10.6654 17.4666 10.6654 16C10.6654 14.5333 9.46536 13.3333 7.9987 13.3333ZM23.9987 13.3333C22.532 13.3333 21.332 14.5333 21.332 16C21.332 17.4666 22.532 18.6666 23.9987 18.6666C25.4654 18.6666 26.6654 17.4666 26.6654 16C26.6654 14.5333 25.4654 13.3333 23.9987 13.3333ZM13.332 16C13.332 14.5333 14.532 13.3333 15.9987 13.3333C17.4654 13.3333 18.6654 14.5333 18.6654 16C18.6654 17.4666 17.4654 18.6666 15.9987 18.6666C14.532 18.6666 13.332 17.4666 13.332 16Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsBig);
export default __webpack_public_path__ + "static/media/dots-big.86113cd4166cefd7a6d505629f50ab09.svg";
export { ForwardRef as ReactComponent };